import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import { UiTopBgSlider, UiTopBgSliderLeftContent, UiInnerTopBgSlider, UiTopBgSliderInnerContent } from "../../../components/common/UiTopBgSliderElements"
import SliderHeart from "../../../../../styles/img/slider-heart-icon.png";
import UiInnerTopSliderCard from "../../../components/common/UiInnerTopSliderCard"
import { UiSliderImageCard } from '../../../components/common/UiSliderImageCard';


export default function ShopProductBanner(props) {

    return (
        <>
            <UiInnerTopBgSlider>
                <UiTopBgSlider>
                    <UiSingleRow className={props.className}>
                        <UiCol lg="12">
                            <UiTopBgSliderInnerContent>
                                <h2>{props.title}</h2>
                                <p className='sb-top-bg-slider__slider-content-description'>{props.description}</p>
                            </UiTopBgSliderInnerContent>
                        </UiCol>
                       
                    </UiSingleRow>
                </UiTopBgSlider>
            </UiInnerTopBgSlider>
        </>
    )
}
